export default "__VITE_ASSET__DjuqIOUY__"